<template>
  <div v-if="authInitError" class="auth-init-error">
    <q-icon name="error_outline" size="48px" color="negative" />
    <p>{{ authInitError }}</p>
    <q-btn color="primary" label="Retry" unelevated @click="retry" />
  </div>
  <div v-else-if="companyStore.error" class="auth-init-error">
    <q-icon name="error_outline" size="48px" color="negative" />
    <p>{{ companyStore.error }}</p>
    <q-btn color="primary" label="Retry" unelevated @click="companyStore.fetchCompanies()" />
  </div>
  <div v-else-if="companyStore.noLinkedCompanies" class="auth-init-error">
    <q-icon name="business_center" size="48px" color="grey-6" />
    <p>You aren't linked to any company yet. Contact an administrator to get access.</p>
    <q-btn color="primary" label="Retry" unelevated @click="companyStore.fetchCompanies()" />
  </div>
  <div v-else-if="companyStore.noPermittedCompanies" class="auth-init-error">
    <q-icon name="lock_outline" size="48px" color="grey-6" />
    <p>You're linked to a company, but don't have any Procurement permissions for it yet. Contact an administrator to get access.</p>
    <q-btn color="primary" label="Retry" unelevated @click="companyStore.fetchCompanies()" />
  </div>
  <div v-else-if="authStore.moduleAccessChecked && !authStore.moduleHasAccess" class="auth-init-error">
    <q-icon name="block" size="48px" color="negative" />
    <p>You don't have access to this module. Contact an administrator to get access.</p>
  </div>
  <template v-else>
    <router-view v-if="authStore.moduleIsUniversal || companyStore.ready" />
    <company-select-dialog v-if="!authStore.moduleIsUniversal" />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from './stores/auth';
import { useCompanyStore } from './stores/company';
import { useBrandingStore } from './stores/branding';
import CompanySelectDialog from './components/CompanySelectDialog.vue';

const authStore = useAuthStore();
const companyStore = useCompanyStore();
// Instantiated for its side-effecting watch (re-applies branding whenever
// the selected company changes) - see stores/branding.ts.
useBrandingStore();
const authInitError = computed(() => authStore.authInitError);

function retry() {
  window.location.reload();
}
</script>

<style scoped>
.auth-init-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: 100vh;
  padding: 24px;
  text-align: center;
}
</style>
